import { render } from "./SlidebarPAtient.vue?vue&type=template&id=94681e62&scoped=true&ts=true"
import script from "./SlidebarPAtient.vue?vue&type=script&lang=ts"
export * from "./SlidebarPAtient.vue?vue&type=script&lang=ts"

import "../assets/scss/component/slidebar.scss?vue&type=style&index=0&id=94681e62&scoped=true&lang=scss"

import exportComponent from "/var/lib/jenkins/workspace/dev.poct.nikted.com/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-94681e62"]])

export default __exports__